import {
  COOLING_TYPES,
  COOLING_TYPE_LABELS,
  HEATING_TYPES,
  HEATING_TYPE_LABELS,
  LAUNDRY_TYPES,
  LAUNDRY_TYPE_LABELS,
  labelledOptions,
} from '@resida/shared';
import { ProfileSection } from './ProfileSection';
import { inputClass, labelClass } from './fieldClasses';
import type { MarketingDraft } from './marketingDraft';

const HEATING_TYPE_OPTIONS = labelledOptions(HEATING_TYPES, HEATING_TYPE_LABELS);
const COOLING_TYPE_OPTIONS = labelledOptions(COOLING_TYPES, COOLING_TYPE_LABELS);
const LAUNDRY_TYPE_OPTIONS = labelledOptions(LAUNDRY_TYPES, LAUNDRY_TYPE_LABELS);

const HEATING_FUEL_TYPES = [
  { value: 'none', label: 'None' },
  { value: 'coal', label: 'Coal' },
  { value: 'electric', label: 'Electric' },
  { value: 'gas', label: 'Natural Gas' },
  { value: 'oil', label: 'Oil' },
  { value: 'propane_butane', label: 'Propane / Butane' },
  { value: 'solar', label: 'Solar' },
  { value: 'wood_pellet', label: 'Wood / Pellet' },
  { value: 'other', label: 'Other' },
];

interface Props {
  draft: MarketingDraft;
  onChange: (patch: Partial<MarketingDraft>) => void;
}

function SelectField({
  id,
  label,
  value,
  options,
  testId,
  onValue,
}: {
  id: string;
  label: string;
  value: string;
  options: { value: string; label: string }[];
  testId: string;
  onValue: (value: string) => void;
}) {
  return (
    <div>
      <label htmlFor={id} className={labelClass}>{label}</label>
      <select id={id} value={value} onChange={(e) => onValue(e.target.value)} data-testid={testId} className={inputClass}>
        <option value="">— Select —</option>
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </select>
    </div>
  );
}

export function ProfileSectionClimateAndLaundry({ draft, onChange }: Props) {
  return (
    <ProfileSection title="Climate and laundry" testId="marketing-details-climate">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <SelectField id="heating-type" label="Heating type" value={draft.heating} options={HEATING_TYPE_OPTIONS} testId="profile-heating-type-select" onValue={(heating) => onChange({ heating })} />
        <SelectField id="cooling-type" label="Cooling type" value={draft.cooling} options={COOLING_TYPE_OPTIONS} testId="profile-cooling-type-select" onValue={(cooling) => onChange({ cooling })} />
        <SelectField id="laundry-type" label="Laundry" value={draft.laundry} options={LAUNDRY_TYPE_OPTIONS} testId="profile-laundry-type-select" onValue={(laundry) => onChange({ laundry })} />
        <SelectField id="heating-fuel" label="Heating fuel" value={draft.heatingFuel} options={HEATING_FUEL_TYPES} testId="profile-heating-fuel-select" onValue={(heatingFuel) => onChange({ heatingFuel })} />
      </div>
    </ProfileSection>
  );
}
